import React, { createContext, useContext, useState, useEffect } from 'react';
import * as clientApi from '../utils/clientApi';

const ClientContext = createContext();

export const useClient = () => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error('useClient must be used within ClientProvider');
  }
  return context;
};

export const ClientProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const storedToken = localStorage.getItem('client_token');
      if (storedToken) {
        setToken(storedToken);
        const data = await clientApi.verifyClientToken();
        if (data.valid) {
          setClient({
            client_id: data.client_id,
            email: data.email,
            name: data.name
          });
          setIsAuthenticated(true);
        }
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      clientApi.clientLogout();
      setIsAuthenticated(false);
      setClient(null);
      setToken(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const data = await clientApi.clientLogin(email, password);
    setToken(data.access_token);
    setClient({
      client_id: data.client_id,
      name: data.name,
      email: data.email
    });
    setIsAuthenticated(true);
    return data;
  };

  const register = async (userData) => {
    const data = await clientApi.clientRegister(userData);
    setToken(data.access_token);
    setClient({
      client_id: data.client_id,
      name: data.name,
      email: data.email
    });
    setIsAuthenticated(true);
    return data;
  };

  const logout = () => {
    clientApi.clientLogout();
    setIsAuthenticated(false);
    setClient(null);
    setToken(null);
  };

  const value = {
    isAuthenticated,
    client,
    token,
    loading,
    login,
    register,
    logout,
    checkAuth
  };

  return (
    <ClientContext.Provider value={value}>
      {children}
    </ClientContext.Provider>
  );
};
